/**
 * Companies whose operations timeline shows aquaculture (fish-log) events.
 * Matches "Sølvtrans" and the admin-only "SØLVTRANS ADMIN" company (and any Sølvtrans* sub-company).
 *
 * Kept in its own lightweight module so it can be imported by the eagerly-loaded route layout
 * without pulling in the heavy aquaculture timeline dependencies (react-query, react-table, ...).
 */
export function isAquacultureTimelineCompany(company: string | undefined): boolean {
	if (company == null) {
		return false
	}
	const key = company.trim().toLowerCase()
	return key.startsWith("sølvtrans") || key.startsWith("solvtrans")
}
